import React, {useState} from 'react'
import View from './view'
import {
  Attempt,
  getReportedExamResults,
  submitBulkExamDate,
} from '../../../../redux/reportExamStatus'
import {useSelector} from 'react-redux'
import {selectOrganization} from '../../../../redux/courses'
import {useAppDispatch} from '../../../../redux/configureStore'
import {useAuth} from '../../../../components/AuthProvider'
import {toggleErrorDialog} from '../../../../redux/config'

export type ExamDateFilter = {
  examDate: string
  courseId: string
  attemptId?: string
}

type Props = {
  examReports?: Attempt[]
}

const ExamStatusCard = ({examReports}: Props) => {
  const [dateFilter, setDateFilter] = useState<ExamDateFilter[]>([])
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const dispatch = useAppDispatch()
  const auth = useAuth()

  const organization = useSelector(selectOrganization)

  const handleChangeDateFilter = (
    examDate: string,
    courseId?: string,
    attemptId?: string,
  ) => {
    if (courseId) {
      setDateFilter(prevDateFilter => {
        const existingIndex = prevDateFilter.findIndex(
          item => item.courseId === courseId,
        )

        if (existingIndex !== -1) {
          const updatedDateFilter = [...prevDateFilter]
          updatedDateFilter[existingIndex] = {examDate, courseId, attemptId}
          return updatedDateFilter
        }

        return [...prevDateFilter, {examDate, courseId, attemptId}]
      })
    }
  }

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true)

      const {type} = await dispatch(
        submitBulkExamDate({auth, dates: dateFilter}),
      )
      if (type === submitBulkExamDate.rejected.type) {
        setIsSubmitting(false)
        throw new Error('Failed to submit exam dates')
      }

      setIsSubmitting(false)
      await dispatch(getReportedExamResults({auth}))
      setDateFilter([])
    } catch (e) {
      console.error('Failed to submit exam dates', e)
      dispatch(
        toggleErrorDialog({
          opened: true,
          error:
            'We were unable to submit or update your exam dates, please retry. If the issue persists please contact our support team',
        }),
      )
      setIsSubmitting(false)
    }
  }

  return (
    <View
      onSubmit={handleSubmit}
      onChangeDateFilter={handleChangeDateFilter}
      isSubmitting={isSubmitting}
      dateFilter={dateFilter}
      examReports={examReports}
      organization={organization}
    />
  )
}

export default ExamStatusCard
